import { Button, Text, VSpacer } from '@/components/DesignSystem';
import { QueryKeys } from '@/constants/QueryKeys';
import { SubwalletApi } from '@/utilities/api/SubwalletApi';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from "react-router-dom";
import { Container, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import SubwalletList from "@/pages/Admin/HierarchyOfRetailers/Wallet/SubwalletList";
import {
  CreateOrEditSubwalletDialog,
} from "@/pages/Admin/HierarchyOfRetailers/Wallet/CreateOrEditSubwalletDialog";

const RetailerWalletOverviewPage = () => {
  const navigate = useNavigate();
  const backToRetailer = () => navigate(-1);
  const { id: retailerId } = useParams<{ id: string }>();

  const [selectedSubwalletId, setSelectedSubwalletId] = useState<string | null>(null);
  const [showCreateSubwalletModal, setShowCreateSubwalletModal] = useState(false);

  const { data: subwallets } = useQuery(
    [QueryKeys.LIST_SUBWALLETS, retailerId],
    () => SubwalletApi.list({ retailerId: retailerId! }),
    { enabled: !!retailerId },
  );

  return (
    <Container maxWidth="lg">
      <Stack direction="row" justifyContent="space-between">
        <Button
          onClick={backToRetailer}
          startIcon={<ArrowBackIcon />}
          testID="back-to-retailer-button"
          variant="text"
        >
          Back
        </Button>
      </Stack>
      <VSpacer size="3" />
      <Stack alignItems="center" direction="row" justifyContent="space-between">
        <Text category="headline-large">
          Manage Wallet
        </Text>
        <Button
          onClick={() => {
            setSelectedSubwalletId(null);
            setShowCreateSubwalletModal(true);
          }}
          startIcon={<AddIcon />}
          testID="create-subwallet-button"
        >
          Create subwallet
        </Button>
      </Stack>
      <VSpacer size="3" />
      {!!subwallets && (
        <SubwalletList
          onEditClicked={(subwalletId) => {
            setSelectedSubwalletId(subwalletId);
            setShowCreateSubwalletModal(true);
          }}
          subwallets={subwallets}
        />
      )}
      {showCreateSubwalletModal && !!retailerId && (
        <CreateOrEditSubwalletDialog
          onClose={() => setShowCreateSubwalletModal(false)}
          retailerId={retailerId}
          selectedSubwalletId={selectedSubwalletId}
        />
      )}
    </Container>
  );
};

export default RetailerWalletOverviewPage;
